/*
 */
/*
 * @Description:
 */
/*
 * @Description:
 */
import Vue from "vue";
import VueRouter from "vue-router";

// 重写push以免重复点击本路由报错
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch((error) => error);
};
Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "main",
		component: () => import("../views/main.vue"),
		meta: {
			requireAuth: true,
		},
		redirect: "/homeView", // 设置路由嵌套的默认首页
		children: [
			{
				path: "homeView",
				name: "homeView",
				component: () => import("../views/homeView/homeView.vue"),
			},
			{
				path: "comLibrary",
				name: "comLibrary",
				component: () => import("../views/comLibrary/comLibrary.vue"),
			},
			{
				path: "familyDetail",
				name: "familyDetail",
				component: () => import("../views/familyDetail/familyDetail.vue"),
			},
			{
				path: "downLoad",
				name: "downLoad",
				component: () => import("../views/downLoad/downLoad.vue"),
			},
			{
				path: "entLibrary",
				name: "entLibrary",
				component: () => import("../views/entLibrary/entLibrary.vue"),
			},
			{
				path: "manuFacturer",
				name: "manuFacturer",
				component: () => import("../views/manuFacturer/manuFacturer.vue"),
			},
			{
				path: "storeDetail",
				name: "storeDetail",
				component: () => import("../views/manuFacturer/storeDetail.vue"),
			},
			{
				path: "userCenter",
				name: "userCenter",
				component: () => import("../views/userCenter/index.vue"),
			},

			{
				path: "regist",
				name: "regist",
				component: () => import("../views/userAccount/regist.vue"),
			},
			{
				path: "findPassword",
				name: "findPassword",
				component: () => import("../views/userAccount/findPassword.vue"),
			},
		],
	},
	{
		path: "/userCertify",
		name: "userCertify",
		component: () => import("../views/userCertify.vue"),
	},
];

const router = new VueRouter({
	mode: "hash",
	routes,
});

export default router;
